import type { ComponentProps } from "react";
import type { Badge } from "@/components/ui/badge";

type SiteStatus = string | null | undefined;

function normalizeSiteStatus(status: SiteStatus) {
  const normalized = status?.trim().toLowerCase();
  return normalized || "active";
}

export function formatSiteStatus(status: SiteStatus) {
  return normalizeSiteStatus(status).replace(/\b\w/g, (match) =>
    match.toUpperCase()
  );
}

export function isSiteAccessActive(status: SiteStatus) {
  return normalizeSiteStatus(status) !== "inactive";
}

export function getSiteStatusBadgeVariant(
  status: SiteStatus
): ComponentProps<typeof Badge>["variant"] {
  const normalized = normalizeSiteStatus(status);

  if (normalized === "active") {
    return "approved";
  }

  if (normalized === "inactive") {
    return "destructive";
  }

  if (normalized === "planned") {
    return "secondary";
  }

  if (normalized === "completed") {
    return "ghost";
  }

  return "outline";
}
